module.exports = __webpack_public_path__ + "08a654963a947c89fe429938cd906b78.png";